// Przykłady dopasowane do branży.
//
// Formularz zbiera dane dla stron z bardzo różnych branż, więc jeden zestaw
// przykładów („wymiana rozrządu") pomaga jednemu klientowi na siedmiu.
// Po wskazaniu branży w kroku 1 podmieniamy podpowiedzi w polach otwartych
// i chipsy pod nimi. Tekst pomocniczy (help) zostaje neutralny — on tłumaczy
// pytanie, przykład jest tylko rozbiegiem.
//
// Slugi muszą się zgadzać z choices pola zgl_02_branza w schema.php.

const NEUTRAL = {
    firma: "Nazwa Twojej firmy",
    opis: "Czym się zajmujecie, dla kogo pracujecie i od kiedy — 2–3 zdania własnymi słowami.",
    uslugi: "pierwsza usługa\ndruga usługa\ntrzecia usługa",
    cennik: "usługa — cena\nkolejna usługa — cena",
    domena: "twojafirma.pl",
    chipsOpis: ["dojazd do klienta", "gwarancja na usługi", "terminy od ręki", "obsługujemy firmy"],
    chipsFaq: ["Ile to kosztuje?", "Jak szybko możecie zacząć?", "Czy wystawiacie fakturę?"],
};

const BRANCHES = {
    warsztat: {
        firma: "Auto-Serwis Kowalski",
        opis: "Naprawiamy auta wszystkich marek — mechanika i elektryka. Działamy w Radomiu od 2010 roku.",
        uslugi: "wymiana rozrządu\ndiagnostyka komputerowa\nklimatyzacja",
        cennik: "wymiana oleju — 120 zł\ndiagnostyka komputerowa — 150 zł",
        domena: "autokowalski.pl",
        chipsOpis: ["dojazd do klienta", "auto zastępcze", "gwarancja na naprawy", "terminy od ręki"],
        chipsFaq: ["Czy honorujecie części klienta?", "Jak długo trwa naprawa?", "Czy dajecie auto zastępcze?"],
    },
    uroda: {
        firma: "Salon Fryzjerski Anna",
        opis: "Strzyżenie, koloryzacja i stylizacja włosów. Pracujemy w centrum miasta od 2015 roku.",
        uslugi: "strzyżenie damskie\nkoloryzacja\nupięcia okolicznościowe",
        cennik: "strzyżenie damskie — 90 zł\nkoloryzacja — od 200 zł",
        domena: "salonanna.pl",
        chipsOpis: ["rezerwacja online", "kosmetyki premium", "dojazd na wesela", "bez kolejek"],
        chipsFaq: ["Czy trzeba się umawiać?", "Ile trwa koloryzacja?", "Czy robicie makijaż ślubny?"],
    },
    gabinet: {
        firma: "Gabinet Fizjoterapii Ruch",
        opis: "Fizjoterapia i rehabilitacja po urazach. Przyjmujemy pacjentów od 2012 roku.",
        uslugi: "terapia manualna\nmasaż leczniczy\nrehabilitacja pourazowa",
        cennik: "wizyta 60 min — 180 zł\nmasaż 30 min — 100 zł",
        domena: "gabinetruch.pl",
        chipsOpis: ["wizyty bez kolejki", "własny sprzęt", "dojazd do pacjenta", "terminy popołudniowe"],
        chipsFaq: ["Czy potrzebne jest skierowanie?", "Ile trwa wizyta?", "Czy przyjmujecie dzieci?"],
    },
    budowlanka: {
        firma: "Remonty Kowalski",
        opis: "Remontujemy mieszkania i domy — od malowania po wykończenia pod klucz. Pracujemy w okolicy od 2011 roku.",
        uslugi: "wykończenia pod klucz\nukładanie płytek\nmalowanie i gładzie",
        cennik: "malowanie — od 25 zł/m²\npłytki — od 90 zł/m²",
        domena: "remontykowalski.pl",
        chipsOpis: ["wycena za darmo", "własne ekipy", "materiały w cenie", "gwarancja na robociznę"],
        chipsFaq: ["Czy robicie wycenę na miejscu?", "Ile trwa remont łazienki?", "Czy sprzątacie po sobie?"],
    },
    gastronomia: {
        firma: "Pizzeria Bella",
        opis: "Pizza z pieca opalanego drewnem i domowe makarony. Działamy w centrum od 2018 roku.",
        uslugi: "pizza na miejscu i na wynos\ncatering na imprezy\nmenu lunchowe",
        cennik: "pizza Margherita — 32 zł\nzestaw lunchowy — 29 zł",
        domena: "pizzeriabella.pl",
        chipsOpis: ["dowóz w 30 minut", "menu dla dzieci", "opcje wegańskie", "sala na imprezy"],
        chipsFaq: ["Czy dowozicie?", "Czy można zarezerwować stolik?", "Czy macie dania bezglutenowe?"],
    },
    sprzatanie: {
        firma: "CzystoTu",
        opis: "Sprzątamy biura i mieszkania — regularnie i po remontach. Działamy w okolicy od 2019 roku.",
        uslugi: "sprzątanie biur\nmycie okien\nsprzątanie po remoncie",
        cennik: "sprzątanie mieszkania — od 150 zł\nmycie okien — od 15 zł/szt.",
        domena: "czystotu.pl",
        chipsOpis: ["własny sprzęt i środki", "stały opiekun", "umowy z firmami", "ubezpieczenie OC"],
        chipsFaq: ["Czy przynosicie własne środki?", "Jak wygląda wycena?", "Czy sprzątacie w weekendy?"],
    },
    inna: NEUTRAL,
};

// pole -> klucz w zestawie przykładów
const PLACEHOLDERS = {
    zgl_01_firma: "firma",
    zgl_06_opis: "opis",
    zgl_07_uslugi: "uslugi",
    zgl_26_cennik_pozycje: "cennik",
    zgl_28_domena_nazwa: "domena",
};

// pole -> klucz listy chipsów
const CHIPS = {
    "f-zgl-06-opis": "chipsOpis",
    "f-zgl-27-faq": "chipsFaq",
};

export function initExamples(form) {
    function apply(slug) {
        const set = BRANCHES[slug] || NEUTRAL;

        Object.entries(PLACEHOLDERS).forEach(([name, key]) => {
            const field = form.querySelector('[name="' + CSS.escape(name) + '"]');
            if (field && set[key]) field.placeholder = set[key];
        });

        Object.entries(CHIPS).forEach(([id, key]) => {
            const group = form.querySelector('[data-chips-for="' + CSS.escape(id) + '"]');
            const chips = set[key];
            if (!group || !chips) return;
            group.innerHTML = "";
            chips.forEach((text) => {
                const btn = document.createElement("button");
                btn.type = "button";
                btn.className = "brief__chip";
                btn.dataset.chip = text;
                btn.textContent = text;
                group.appendChild(btn);
            });
        });
    }

    const inputs = Array.from(form.querySelectorAll('input[name="zgl_02_branza"]'));
    if (!inputs.length) return;

    inputs.forEach((input) => {
        input.addEventListener("change", () => {
            if (input.checked) apply(input.value);
        });
    });

    // stan początkowy (także po przywróceniu szkicu)
    const checked = inputs.find((input) => input.checked);
    apply(checked ? checked.value : "");

    return { apply };
}
